import React, { useState, useEffect, useContext } from "react";

import AuthService from "../../utilities/services/auth.service";
import UserContext from "../../context/User/User";

import { ORGANIZATION_PERMISSION_SLUGS } from "@blocktickets/shared-utils";
import { checkPermission, formatString } from "../../utilities/helpers";
import { getAccountBalance } from "../../utilities/api";

import { Payouts } from "./Payouts";
import { NoPermissionsContainer } from "../NoPermissionsContainer";
import { PageLoadingContainer } from "../PageLoadingContainer";

const moment = require("moment");

function mapStripePayoutsForList(stripePayouts, linkedBankAccount) {
  const bankName = linkedBankAccount?.data?.[0]?.bank_name ?? "Payout";
  return (stripePayouts ?? []).map((p) => ({
    id: p.id,
    date: moment.unix(p.arrival_date ?? p.created).format("MMM D, YYYY"),
    event: bankName,
    invoice: p.id,
    price: p.amount / 100,
    status: formatString(p.status ?? ""),
  }));
}

export default function PayoutsWrapper() {
  const { orgPermissions } = useContext(UserContext);

  const { getPermissions } = AuthService;

  const orgPermissionsReady = orgPermissions?.length > 0;
  const hasPermission =
    orgPermissionsReady &&
    checkPermission(
      getPermissions(),
      ORGANIZATION_PERMISSION_SLUGS.VIEW_BALANCE_PAYOUTS,
    );

  const [payouts, setPayouts] = useState([]);
  const [loading, setLoading] = useState(true);

  const organization = AuthService.getOrg()[0];
  const accountId = organization?.connected_account_id;

  useEffect(() => {
    if (!orgPermissionsReady || !hasPermission) return;

    let cancelled = false;
    setLoading(true);
    getAccountBalance(accountId)
      .then((res) => {
        if (cancelled) return;
        const raw = res?.data?.payouts?.data;
        setPayouts(mapStripePayoutsForList(raw, res?.data?.linkedBankAccount));
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setPayouts([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [accountId, orgPermissionsReady, hasPermission]);

  if (!orgPermissionsReady) {
    return <PageLoadingContainer />;
  }

  if (!hasPermission) {
    return <NoPermissionsContainer />;
  }

  if (loading) {
    return <PageLoadingContainer />;
  }

  return (
    <div className="position-relative">
      <section className="wrapper">
        <header className="section-header">
          <div className="section-heading section-heading--secondary">
            <h1>Payouts</h1>
          </div>
          <p className="section-header-desc">
            Keep track of when your money is being processed or has been sent
          </p>
        </header>
        <Payouts payouts={payouts} />
      </section>
    </div>
  );
}
